import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalType } from '@k12/models';
import { Observable, map, merge, take, tap } from 'rxjs';
import { ModalDialogComponent } from './modal-dialog.component';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmButtonText?: string;
  closeButtonText?: string;
  warning?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private readonly dialog = inject(MatDialog);

  confirm(options: ConfirmDialogOptions): Observable<boolean> {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      backdropClass: 'custom-dialog-backdrop',
      panelClass: 'custom-dialog',
      disableClose: true,
      data: {
        align: 'center',
        modalType: ModalType.ConfirmModal,
        title: options.title,
        message: options.message,
        confirmButtonText: options.confirmButtonText ?? 'Continue',
        closeButtonText: options.closeButtonText ?? 'Cancel',
        warning: options.warning ?? true
      }
    });

    return merge(
      dialogRef.componentInstance.confirmModal.pipe(map(() => true)),
      dialogRef.afterClosed().pipe(map(() => false))
    ).pipe(
      take(1),
      tap((confirmed) => {
        if (confirmed) dialogRef.close();
      })
    );
  }
}
